export const MD_MEDIA_QUERY = '(min-width: 768px)'
export const COLUMN_GAP_PX = 12
